<template>
  <div>
    <a-card class="l-container mt-4 mb-4">
      <a-button @click="visible = true" class="btn3"  preset="card"> Start Me up </a-button>
    </a-card>

    <Modal :visible="visible" @ok="visible = false" @cancel="visible = false" class="h-5/6">
      <a-card style="max-width: 600px;" :bordered="false" class="card">
        <div>
          <div class="head1">マイリストに追加</div>
        <div class="grid grid-cols-1">
          <div class="lh1"><a-checkbox @change="onChange">家族旅行</a-checkbox></div>
          <div class="lh1"><a-checkbox @change="onChange">ランチ</a-checkbox></div>
          <div class="lh1"><a-checkbox @change="onChange">美容関連</a-checkbox></div>
          <div class="ptd">新しいマイリストを作成</div>
        </div>
        <div class="grid grid-cols-3" style="display: flex
        ">
        <a-input placeholder="家族旅行リスト" />
        <a-button class="btn2"><span>作成</span></a-button>
        </div>

        <div class="btnd"><a-button class="btn1" ><span>追加する</span></a-button></div>
        </div>
      </a-card>
    </Modal>
  </div>
</template>

<script>
import { Modal } from '@/components/primitive'

export default {
  components: {
    Modal
  },
  data() {
    return {
      visible: false
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>